import { useState, useEffect, memo } from 'react';
import { Sparkles } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const slogans = [
  "Play Hard. Dominate Smart.",
  "Bangladesh's Premier eFootball Community.",
  "Viper Strike United — Champions Rise Here.",
  "Where Legends Are Made.",
  "United We Strike, Together We Win.",
];

function RotatingSloganComponent() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    // Slower rotation on mobile to reduce CPU usage
    const rotationInterval = isMobile ? 6000 : 4000;
    
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % slogans.length);
        setIsVisible(true);
      }, isMobile ? 200 : 500);
    }, rotationInterval);

    return () => clearInterval(interval);
  }, [isMobile]);

  return (
    <div className="flex items-center justify-center gap-1.5 md:gap-2 py-2 md:py-4">
      <Sparkles className="h-3 w-3 md:h-4 md:w-4 text-primary/60" />
      <p 
        className={`text-xs md:text-base text-muted-foreground italic transition-opacity duration-200 md:duration-500 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        "{slogans[currentIndex]}"
      </p>
      <Sparkles className="h-3 w-3 md:h-4 md:w-4 text-primary/60" />
    </div>
  );
}

export const RotatingSlogan = memo(RotatingSloganComponent);
